module.exports = __webpack_public_path__ + "img/son.e3175102.svg";